var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "big-logo",
      attrs: {
        width: "100",
        height: "101",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M4.34784 4.3913H47.8261V48.3043H4.34784V4.3913Z",
          fill: "#F35325"
        }
      }),
      _c("path", {
        attrs: {
          d: "M52.1739 4.3913H95.6522V48.3043H52.1739V4.3913Z",
          fill: "#81BC06"
        }
      }),
      _c("path", {
        attrs: {
          d: "M4.34784 52.6956H47.8261V96.6087H4.34784V52.6956Z",
          fill: "#05A6F0"
        }
      }),
      _c("path", {
        attrs: {
          d: "M52.1739 52.6956H95.6522V96.6087H52.1739V52.6956Z",
          fill: "#FFBA08"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }